var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{staticClass:"order-positon",attrs:{"title":_vm.$t('trade.position')}},[_c('RadioBox',{attrs:{"options":_vm.options},model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }